import { render, staticRenderFns } from "./JLCT1View.vue?vue&type=template&id=4f9a8f86&"
import script from "./JLCT1View.vue?vue&type=script&lang=js&"
export * from "./JLCT1View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports